<template>
<div class="chapter">
<div class="inner_page">
<h1>On Someone Else’s Nickel:<br/>
  A Life in Television, Sports, and Travel</h1>
<h3 class="sigil_not_in_toc">Tim Ryan</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?5af5b973